module.exports = __webpack_public_path__ + "media/Video2.5a59d0ab.mp4";